import { fieldTypes } from './field-types.js';
export const initializeFieldCategoryMapping = function () {
    const categoryMappings = Object.keys(fieldTypes).reduce((accumulatedCategoryMappings, categoryKey) => {
        const categoryMapping = fieldTypes[categoryKey].reduce((mapping, field) => {
            mapping.push(field.type);
            return mapping;
        }, []);
        categoryMapping.forEach((fieldType) => {
            accumulatedCategoryMappings[fieldType] = categoryKey;
        });
        return accumulatedCategoryMappings;
    }, {});
    return categoryMappings;
};
